export const data = [
  {
    id: 1,
    title: "What is Foodies ?",
    desc: "foodies is a food delivery web application developed from scratch using React and Redux Toolkit. It allows users to conveniently order food from various restaurants and explore diverse cuisines.",
  },
  {
    id: 3,
    title: "How is data fetched in foodies?",
    desc: "Data is fetched from Swiggy's live API, providing real-time information about restaurants, menus, and other details. This ensures that users get the latest and most accurate data when using foodies.",
  },
  {
    id: 2,
    title: "Tell us about the bundler and tools used in the project.",
    desc: "foodies is bundled using Parcel, a fast, zero-config web application bundler. The integration of Babel ensures seamless compatibility with the latest ECMAScript standards, enhancing code readability and maintainability.",
  },

  {
    id: 4,
    title: "Why did you choose React and Redux Toolkit for foodies?",
    desc: "React provides a flexible and efficient way to build user interfaces, and Redux Toolkit simplifies state management. Together, they enhance the development process, making foodies a responsive and dynamic web app.",
  },

  {
    id: 5,
    title: "What features does foodies offer?",
    desc: "foodies allows users to browse restaurants, view menus, and place food orders. The integration of Redux Toolkit ensures efficient state management, providing a seamless and interactive user experience.",
  },
  {
    id: 6,
    title: "How is responsive design implemented in foodies?",
    desc: "foodies employs responsive design principles to ensure a seamless user experience across various devices and screen sizes. This involves using CSS media queries and flexbox/grid layouts to adapt the UI components dynamically. Responsive design in foodies aims to provide an optimal viewing and interaction experience for users on desktops, tablets, and mobile devices.",
  },
];
